import Swal from "sweetalert2";

const Utilities = {
    async confirmaionDialog(title,text,confirm_button_text) {
        return await Swal.fire({
            title: title,
            text: text,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#7367F0",
            cancelButtonColor: "#d33",
            confirmButtonText: confirm_button_text,
        })
    },
    async confirmDialog(title, msg, tag) {
        Swal.fire(title, msg, tag);
    }
}

export default Utilities